import React from 'react';

export const InvalidError = (props) => {
    const { errorMessage } = props;
    return (
        <small style={{ color: 'red' }} className="p-invalid">
            {errorMessage}
        </small>
    );
};